import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown"
import ViewWeekIcon from "@mui/icons-material/ViewWeek"
import { IconButton, Popover } from "@mui/material"
import type { GridApiCommon, GridColDef } from "@mui/x-data-grid"
import Box from "@mui/material/Box"
import Stack from "@mui/material/Stack"
import { MutableRefObject, useEffect, useState } from "react"

import Switch from "@components/switch"

import styles from "./styles"

export default function HeaderAppearance({
  columns,
  apiRef
}: {
  columns: GridColDef[]
  apiRef: MutableRefObject<GridApiCommon>
}) {
  const [filterAnchorEl, setFilterAnchorEl] =
    useState<HTMLButtonElement | null>(null)
  const [initialVisibleColumns, setInitialVisibleColumns] = useState<{
    [key: string]: boolean
  }>(
    columns.reduce((acc: { [key: string]: boolean }, clg) => {
      acc[clg.field] = true
      return acc
    }, {})
  )

  useEffect(() => {
    apiRef?.current?.setColumnVisibilityModel(initialVisibleColumns)
  }, [apiRef, initialVisibleColumns])

  function handleClickFilter(event: React.MouseEvent<HTMLButtonElement>) {
    setFilterAnchorEl(event.currentTarget)
  }

  return (
    <>
      <IconButton
        disableRipple
        sx={
          !!filterAnchorEl
            ? styles.optionContainerActive
            : styles.optionContainer
        }
        onClick={(event) => {
          handleClickFilter(event)
          event.stopPropagation()
        }}
      >
        <ViewWeekIcon />
        <KeyboardArrowDownIcon />
      </IconButton>
      <Popover
        open={!!filterAnchorEl}
        anchorEl={filterAnchorEl}
        onClose={() => setFilterAnchorEl(null)}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center"
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center"
        }}
        sx={{
          "& > *": {
            borderRadius: 2.3,
            boxShadow: "0px 2px 8px #00000029"
          },
          mt: 1
        }}
      >
        {columns
          .map((clg) => {
            return (
              <Stack
                direction={"row"}
                justifyContent={"space-between"}
                alignItems={"center"}
                py={1}
                px={2}
                gap={1}
                key={clg.field}
              >
                <Box>{clg.headerName}</Box>
                <Switch
                  defaultChecked={initialVisibleColumns[clg.field]}
                  disabled={clg.description === "fixed"}
                  onClick={() =>
                    setInitialVisibleColumns((prevState) => ({
                      ...prevState,
                      [clg.field]: !prevState[clg.field]
                    }))
                  }
                />
              </Stack>
            )
          })
          .filter((clg) => clg.key !== "rightIcon")}
      </Popover>
    </>
  )
}
